export default {
    en: {
        ACTIVITY_TABLE_EMPTY: "The competition has no activities.",
        ACTIVITY_TABLE_TIME: "Time",
        ACTIVITY_TABLE_MESSAGE: "Activity",
        ACTIVITY_WINDOW_LABEL: "Competition Activity Table"
    }
};
